import { ReactElement, ReactNode } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, Typography, useTheme } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

const StyledCurrency = styled(Typography)<{ $color: string }>`
  &.currency-container {
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;

    .currency {
      color: ${({ $color }) => $color};

      &.emphasize {
        font-size: 2em;
        font-weight: semibold;
      }
    }
  }
`;

interface CurrencyProps {
  className?: string;
  unitOfTime?: string | ReactNode;
  emphasize?: boolean;
  color?: string;
  tooltip?: string | ReactElement;
  value: number;
  currency?: string;
  sign?: string;
  before?: ReactNode;
  after?: ReactNode;
}
export const Currency = ({
  className,
  unitOfTime,
  emphasize,
  color,
  tooltip,
  value,
  currency = 'USD',
  sign,
  before,
  after,
}: CurrencyProps) => {
  const { palette } = useTheme();
  const currencyColor = color ?? palette.primary.main;
  return (
    <StyledCurrency variant="body1" $color={currencyColor} className={clsx('currency-container', className)}>
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoIcon fontSize="small" />
        </Tooltip>
      )}
      {before}
      <span className={clsx('currency', { emphasize })}>
        {sign}
        <FormattedNumber style="currency" value={value} currency={currency} maximumFractionDigits={2} />
      </span>
      {after}
      {unitOfTime && (
        <>
          <span className="divider">
            <FormattedMessage id="unit-divider" defaultMessage="/" />
          </span>
          <span className="frequency">{unitOfTime}</span>
        </>
      )}
    </StyledCurrency>
  );
};
